import { useSelector } from 'react-redux'

import { Box, Flex, useDisclosure } from '@chakra-ui/react'

import { FiltersButton, SearchInput } from '@/components/ui'
import { guardToursFilterCountSelector } from '@/redux/ui/uiSlice'

import { GuardToursFilterDrawer } from './GuardToursFilterDrawer'

interface FilterHeaderIProps {
  filter?: string
  setFilter?: React.Dispatch<React.SetStateAction<string>>
}

export const FilterHeader = ({ filter, setFilter }: FilterHeaderIProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const filterCount = useSelector(guardToursFilterCountSelector)

  return (
    <>
      <Box
        bgColor='white'
        borderBottom='1px solid #D5DCE4'
        boxShadow='md'
        mb='5px'
        px={{ md: 0, lg: 10 }}
        py='6'
        w='full'
      >
        <Flex alignItems='center' justifyContent='space-between' m='auto'>
          <Box maxW='300px' w='full'>
            <SearchInput
              dataTestId='guardToursPage_tableHeader_searchInput'
              onChange={(e) => setFilter(e.target.value)}
              placeholder='Search or Filter'
              value={filter}
            />
          </Box>
          <FiltersButton
            data-testid='guardToursPage_tableHeader_filtersButton'
            filterCount={filterCount}
            onOpen={onOpen}
          />
        </Flex>
      </Box>
      {isOpen && <GuardToursFilterDrawer isOpen={isOpen} onClose={onClose} />}
    </>
  )
}
